module.exports = __webpack_public_path__ + "img/金币.e550e65e.png";